var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-date"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.333 10H3.33301M16.333 2V6M8.33301 2V6M10.833 14L12.333 13V18M11.083 18H13.583M8.13301 22H16.533C18.2132 22 19.0532 22 19.695 21.673C20.2595 21.3854 20.7184 20.9265 21.006 20.362C21.333 19.7202 21.333 18.8802 21.333 17.2V8.8C21.333 7.11984 21.333 6.27976 21.006 5.63803C20.7184 5.07354 20.2595 4.6146 19.695 4.32698C19.0532 4 18.2132 4 16.533 4H8.13301C6.45285 4 5.61277 4 4.97104 4.32698C4.40655 4.6146 3.94761 5.07354 3.65999 5.63803C3.33301 6.27976 3.33301 7.11984 3.33301 8.8V17.2C3.33301 18.8802 3.33301 19.7202 3.65999 20.362C3.94761 20.9265 4.40655 21.3854 4.97104 21.673C5.61277 22 6.45285 22 8.13301 22Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar-date.b71ceceb4acf50e3e8acbd192688f3b7.svg";
export { ForwardRef as ReactComponent };